import { useRoutes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { defaultRoutes } from './routes'
import privateRouts from './privateRouts'

const Routes = (props) => {
  const user = useSelector((state) => state.user)
  return useRoutes([...privateRouts({ ...props, user }), ...defaultRoutes({ ...props, user })],
    process.env.PUBLIC_URL)
}

export default Routes
